import { useBeforeInstallPromptContext } from '~/providers/before-install-prompt-provider'
import { isInStandalone } from '~/utils/is-stand-alone'

export const useCanDisplayInstallOnAndroid = () => {
  const { beforeInstallPromptEvent } = useBeforeInstallPromptContext()

  return !!beforeInstallPromptEvent && !isInStandalone()
}
